<template>
  <div class="pre-booked-offers">
    <p
      v-if="bookedOffer && remainingDays === 0"
      class="pre-booked-offers__warning is-orange">
      <font-awesome-icon :icon="['fal', 'exclamation-triangle']" class="fa-lg" />
      {{ $t('procedures.steps.preBookedOffers.firstParagraphe') }}
    </p>
    <p v-else-if="bookedOffer" class="pre-booked-offers__warning is-orange">
      <font-awesome-icon :icon="['fal', 'exclamation-triangle']" class="fa-lg" />
      &nbsp;
      <span
        v-html="$t('procedures.steps.preBookedOffers.secondParagraphe', { remainingDays })">
      </span>
    </p>
    <template v-if="isIndividual">
      <p v-html="$t('procedures.steps.preBookedOffers.thirdParagrapheIndividual')"></p>
      <p>{{ $t('procedures.steps.preBookedOffers.forthParagrapheIndividual') }}</p>
      <ul class="pre-booked-offers__list">
        <li v-for="offer in offers" :key="offer.id">
          <booked-offer :is-active-step="isActiveStep" :offer="offer" />
        </li>
      </ul>
    </template>
    <template v-else>
      <p>{{ $t('procedures.steps.preBookedOffers.thirdParagraphe') }}</p>
      <ul class="pre-booked-offers__list">
        <li v-for="offer in offers" :key="offer.id">
          <booked-offer :is-active-step="isActiveStep" :offer="offer" />
        </li>
      </ul>
      <p v-if="preBooked">
        {{ $t(getTextType('procedures.steps.preBookedOffers.forthParagraphe')) }}
      </p>
    </template>
  </div>
</template>

<script>
import BookedOffer from '@/components/procedures/prebookStepper/BookedOffer.vue';
import pathText from '@/utils/helpers/pathText';

export default {
  name: 'preBookedOffers',
  components: {
    BookedOffer,
  },
  props: {
    isActiveStep: {
      type: Boolean,
    },
    offers: {
      type: Array,
      default: () => ([]),
    },
    isIndividual: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    bookedOffer() {
      return this.offers.find(({ status }) => status === 'REP_PREBOOKED');
    },
    preBooked() {
      return this.offers.find(({ status }) => status === 'REP_PREBOOK_WAIT');
    },
    remainingDays() {
      const today = new Date();
      const date = new Date(this.bookedOffer.prebooked_until);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const days = Math.ceil((new Date(`${year}-${month}-${day}`) - today) / (1000 * 60 * 60 * 24));
      return days > 0 ? days : 0;
    },
  },
  methods: {
    getTextType(text) {
      return pathText.getTextType(text);
    },
  },
};
</script>

<style lang="scss" scoped>

.pre-booked-offers {
  &__warning {
    font-weight: 600;
    font-size: 18px;
  }
  &__list {
    margin-top: 0;
    margin-bottom: 10px;
  }
  .is-orange {
    color: $--color-warning;
  }
}
</style>
